import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy} from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ApiRequest } from "src/app/_models";
import { EmailModel } from "src/app/_models/common/EmailModel";
import { Claims } from "src/app/_models/common/claims";
import { UserRequestBase, Userrequestdto,} from "src/app/_models/user/userrequestdto";
import { EmailService } from "src/app/_services/common/email.service";
import { EMAIL_REGEX } from "src/util/constants";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgOtpInputModule } from "ng-otp-input";
import { ButtonComponent } from '../../../shared/design-system/button/button.component';
import { ButtonConfig } from "../../../shared/design-system/button/button.modal";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-otp-verification",
    templateUrl: "./otp-verification.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NgOtpInputModule,
      ButtonComponent
    ]
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
  @Output() gotoNextStepEvent = new EventEmitter<any>();  

  otpConfig = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '0'
  };
  continueConfig!: ButtonConfig;
  userrequest: UserRequestBase;
  userrequestdto: Userrequestdto;
  showResendEmail = false;
  otpCode: string = '';
  isValidOTPEntered = false;
  newEmail = "";
  claims: Claims;
  interval: any;
  timerInterval: any;
  remainingTime: number = 32;
  canResendOTP: boolean = false;
  showGetCodeInput = false;
  isInvalidNewEmail = false;

  constructor(
    private emailService: EmailService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.userrequestdto = JSON.parse(localStorage.getItem("registereduser"));
    this.newEmail = this.userrequestdto.LoginId;
    this.interval = setInterval(() => {
      this.resendOTP();
    }, 600000);
    this.startTimer();
    this.setButtonConfig();
  }

  setButtonConfig() {
    this.continueConfig = {
      id: 'otp-continue-btn',
      label: this.translate.instant('continue'),
      color: "primary", 
      size: "lg",
      block: true,
      disabled: this.otpCode.length < 4 || !this.isValidOTPEntered,
      ariaLabel: this.translate.instant('continue')
    }
  }

  startTimer() {
    this.remainingTime = 32;
    this.canResendOTP = false;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        this.canResendOTP = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  validateOTP() {
    this.showResendEmail = false;
    if (this.otpCode && this.otpCode.length === 4) {
      if (this.userrequestdto.OTP.toString() === this.otpCode) { 
        this.isValidOTPEntered = true;
        this.showGetCodeInput = false;
        clearInterval(this.interval);       
      } else {     
          this.toastr.error(this.translate.instant('otp_is_invalid'), '', {
            timeOut: 15000
          });
        this.isValidOTPEntered = false;
      }
    } else {
      this.isValidOTPEntered = false;
    }
  }

  goToNextStep() {
    this.gotoNextStepEvent.emit(4);
  }

  onGetCode() {
    this.showResendEmail = true;
    this.otpCode = '';
  }

  resendOTP() {
    let em = new EmailModel();
    em.to = this.newEmail;
    em.bCC = environment.otpBccEmails;
    em.templateName = "OnboardingOTP";
    em.userId = 0;
    em.subjct = "OTP";
    em.sentTime = 0;
    em.deliveredTime = 0;
    em.status = 1;
    em.emailLogId = this.newGuid();
    var otp = Math.floor(1000 + Math.random() * 9000);
    em.keyValuePairs["OTP"] = otp.toString();
    let req = new ApiRequest<EmailModel>("", 1, "");
    req.requestInfo = em;
    this.emailService.SendEmail(req).subscribe(() => {
      this.userrequestdto.LoginId = this.newEmail;
      this.userrequestdto.OTP = otp;
      localStorage.setItem(
        "registereduser",
        JSON.stringify(this.userrequestdto)
      );
      this.showResendEmail = false;
      this.showGetCodeInput = false;
      this.startTimer();
    });
  }

  newGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  onDigitInput(value: string) {
    this.otpCode = value;
    this.validateOTP();
    this.continueConfig = {
      ...this.continueConfig,
      disabled: this.otpCode.length < 4 || !this.isValidOTPEntered
    };
  }

  isInvalidEmail() {
    this.isInvalidNewEmail = !EMAIL_REGEX.test(this.newEmail);
  }  

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  backToRegister() {
    localStorage.setItem("backFromOTP", "true");
    this.gotoNextStepEvent.emit(2);
  }
}
